(function () {
    "use strict";

    Directives.CompanySubscriptionPricingFormDirective =  function CompanySubscriptionPricingFormDirective() {

        return {
            scope:{
                hideFeatures: '=',
                discountPercentage: '=',
                defaultPricingPlan: '=',
                onPaymentSuccess: '&?',
                pushForDemo: "="
            },
            templateUrl : 'angular/app/modules/core/features/settings/company/subscription/company_subscription_pricing_form_directive_template.html',
            controller : 'CompanySettingsPricingController',
            controllerAs : 'pricingVm',
            bindToController : true
        };
    };
}());